import { ReleasesContainer } from 'components/carousels/ReleasesContainer'
import { ReleaseCard } from 'components/release-calendar/ReleaseCard'
import { ReleaseCardSkeleton } from 'components/release-calendar/ReleaseCardSkeleton'
import { useFutureReleases } from 'contexts/hooks/useReleaseCalendar'
import { range } from 'utils/arrays'

export const ReleasesCarousel = () => {
  const {
    data: { list },
    isFetchedAfterMount,
  } = useFutureReleases({ pagination: { pageSize: 15 } })

  if (!list || !isFetchedAfterMount) {
    return (
      <ReleasesContainer>
        {range(0, 6).map(i => (
          <ReleaseCardSkeleton key={i} />
        ))}
      </ReleasesContainer>
    )
  }

  if (!list.length) return null

  return (
    <ReleasesContainer>
      {list.map(release => (
        <ReleaseCard key={release.id} {...release} />
      ))}
    </ReleasesContainer>
  )
}
